import { start as startUserlane } from '@app/adapters/tutorial'

window.addEventListener('trigger-tutorial', (e) => {
  e.preventDefault()

  startUserlane(e.detail.payload.id)
})

const triggerTutorialfromDom = (e) => {
  e.preventDefault()

  const { tutorialId } = e.currentTarget.dataset

  startUserlane(tutorialId)
}

window.onDomLoad(($dom) => {
  const turorialLinks = $dom[0].querySelectorAll(
    '[data-trigger-tutorial="true"]'
  )

  turorialLinks.forEach((link) => {
    link.addEventListener('click', triggerTutorialfromDom)
  })
})
